module.exports = __webpack_public_path__ + "img/Flecha_lado.e971128d.svg";